import React from 'react';
import { get } from 'lodash';
import { Box, Stack } from '@mui/material';
import { BasePrice } from 'modules/equipment/types';
import { CurrencyInputField } from 'components/form';
import { ListingForm } from 'components/shared/TableListing/types';
import { FieldPath, useFormContext, useWatch } from 'react-hook-form';
import { RenderWithCondition } from 'components/shared/Conditional/RenderWithCondition';

import { AttachmentChargeValue } from './AttachmentChargeValue';
import { QuoteChargeListingEntity, QuoteChargeType } from '../../../../../types';

interface Props {
  rowIndex: number;
  type: keyof BasePrice;
}

export const ChargeValueCell = ({ type, rowIndex }: Props) => {
  const { control } = useFormContext<ListingForm<QuoteChargeListingEntity>>();

  const fields: Record<QuoteChargeType, Record<'valuePath', FieldPath<ListingForm<QuoteChargeListingEntity>>>> = {
    [QuoteChargeType.Equipment]: {
      valuePath: `bodyFields.${rowIndex}.equipment.price.${type}`,
    },
    [QuoteChargeType.Invoice]: {
      valuePath: `bodyFields.${rowIndex}.charge.price.${type}`,
    },
  };

  const { type: cellType, equipment } = useWatch({ control, name: `bodyFields.${rowIndex}` });

  return (
    <Stack width="100%" height="100%" gap="0.5rem">
      <Box sx={{ paddingBottom: '2.5rem' }}>
        <CurrencyInputField
          allowNegative
          control={control}
          name={fields[cellType].valuePath}
          textFieldProps={{
            variant: 'outlined',
          }}
        />
      </Box>

      <RenderWithCondition condition={!!equipment?.attachments}>
        {equipment?.attachments?.map((_, index) => (
          <AttachmentChargeValue key={index} type={type} rowIndex={rowIndex} attachmentIndex={index} />
        ))}
      </RenderWithCondition>
    </Stack>
  );
};
